import { Box, Button, Grid, TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import DeleteIcon from "@mui/icons-material/Delete";

const ComplementsItens = ({
  complemento,
  erros,
  handleChangeComplementoItem,
  optionsCurrency,
  handleRemoveComplementoItem,
}) => {
  return (
    <>
      {complemento.complementoItens?.map((complementoItem, index) => (
        <Box key={complementoItem.id}>
          <Grid container spacing={1} alignItems="center">
            <Grid size={{ xs: 12, sm: 3 }}>
              <TextField
                variant="outlined"
                fullWidth
                required
                label="Descrição do item"
                name="descricao"
                error={
                  complementoItem.descricao === "" &&
                  !!erros.nomeItemComplemento
                }
                helperText={
                  complementoItem.descricao === ""
                    ? erros.nomeItemComplemento
                    : null
                }
                placeholder="Ex: MARGHERITA"
                defaultValue={complementoItem.descricao || ""}
                onBlur={(event) => handleChangeComplementoItem(event, index)}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <TextField
                variant="outlined"
                fullWidth
                label="Descrição adicional"
                name="descricaoComplementar"
                placeholder="Ex: Molho Pomodoro e queijo mussarela"
                defaultValue={complementoItem.descricaoComplementar || ""}
                onBlur={(event) => handleChangeComplementoItem(event, index)}
              />
            </Grid>

            <Grid size={{ xs: 6, sm: 1.5 }}>
              <TextField
                variant="outlined"
                fullWidth
                label="Ordem"
                name="ordem"
                defaultValue={complementoItem.ordem || ""}
                onBlur={(event) => handleChangeComplementoItem(event, index)}
              />
            </Grid>

            <Grid size={{ xs: 6, sm: 1.5 }}>
              <TextField
                variant="outlined"
                fullWidth
                label="ID Ext."
                name="codigoExterno"
                defaultValue={complementoItem.codigoExterno || ""}
                onBlur={(event) => handleChangeComplementoItem(event, index)}
              />
            </Grid>

            <Grid size={{ xs: 6, sm: 1.5 }}>
              <NumericFormat
                customInput={TextField}
                label="Valor"
                variant="outlined"
                defaultValue={complementoItem.valor}
                thousandSeparator=""
                decimalSeparator=","
                decimalScale={optionsCurrency.decimalPlaces}
                fixedDecimalScale
                prefix={optionsCurrency.currencySymbol}
                fullWidth
                name="valor"
                onBlur={(event) =>
                  handleChangeComplementoItem(event, index, event.target.value)
                }
              />
            </Grid>

            <Grid
              size={{ xs: 6, sm: 0.5 }}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                onClick={() =>
                  handleRemoveComplementoItem(complementoItem, index)
                }
                sx={{ width: "1rem" }}
                color="error"
              >
                <DeleteIcon />
              </Button>
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
};

export default ComplementsItens;
